import React, { Component } from "react";
import Select from "react-select";
import { Button, Col, Row, Form, Modal } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { retailerService, revenuecostService } from "../../../../Services";
import JobService from "../../../../Services/JobService";
import * as JobOptions from "../../../../Function/defaultJobOptions";
import { customerServiceService } from "../../../../Services";
import helperFunction from "../../../../Function/helperFunction";
import moment from "moment";
import { SubAdminService } from "../../../../Services/SubAdminService";
import { Storage } from "../../../../Storage/Storage";

class QuickInfo extends Component {
  state = {
    invoices: [],
    costs : []
  };

  constructor() {
    super();
    this.state = {
      serviceTypeValue: "",
      shipmentValue: "",
      retailers: [],
      jobStatus: "",
      showJobStatusModal: false,
      optionalJobStatus: "",
      customers : [],
      isDraft : false,
      myData: null, // Initial state
      emp_name: null, // Initial state

    };
  }

  componentDidMount = () => {
    this.getRetailer();
    this.setState({ jobStatus: this.props.isJobOpen });
    this.getInvoices();
    this.getCosts();
    const data = localStorage.getItem('user_type');
    const employee = localStorage.getItem('emp_name');
    this.getCustomerService()
    if (data) {
      this.setState({ myData: data });
    }
    if (employee) {
      this.setState({ emp_name: employee });
    }
  };

  // componentDidUpdate(prevProps) {
  //     if (this.props.generalDetails?.retailer_name !== prevProps.prefillState?.city) {
  //         this.setState({
  //             address: this.props.prefillState?.city
  //         })
  //     }
  // }
  


  getCustomerService = (emp) => {
    let param = {role : "customer_service"} 
    customerServiceService.getCustomerService(param).then((res)=>{
      if (res.status) {
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].employee_name){
            arr.push({
              ...res.data[i],
              value: res.data[i]?.employee_name,
              label: res.data[i]?.employee_name,
            });
          }
        }
        this.setState({ customers: arr });
        // let selCS = arr.find((itm)=> itm?.employee_name === emp)
        // console.log(selCS,'selCS',arr)
        // this.props.onChangeValue(selCS.value, "general_details", "customer_service")
      }
    })
  }

  getRetailer = () => {
    let params = {}
    const useDetails = Storage.get('auth')
    if(useDetails?.role && useDetails.role==="marketplace_handler"){
      params["type"] = "marketplace"
    }
    retailerService.getRetailer(params).then((res) => {
      if (res.status) {
        let listArry = [];
        res.data.map((val) => {
          listArry.push({
            value: val._id,
            label: val.retailer_name,
            referral_token: val.referral_token,
            sales_person: val.contact_name,
          });
        });
        if(useDetails?.role && useDetails.role==="marketplace_handler"){
          listArry = listArry.filter((item)=> useDetails.retailers.includes(item.value))
        }
        this.setState({ retailers: listArry });
      }
    });
  };

  getRetailerDetailById = (id) => {
    return retailerService.getRetailerDetails({ id }).then((res) => {
      if (res.status) {
        return res.data[0].customer_discount;
      }
      return false;
    });
  };

  setData() {
    const { serviceTypeValue, shipmentValue } = this.state;
    const { jobShipmentData } = this.props;
    if (jobShipmentData != undefined && jobShipmentData.destination) {
      let sData = JobOptions.serviceType().filter((e) =>
        jobShipmentData.servic_type.includes(e.value)
      );
      let shipData = JobOptions.shippingMode().filter((e) =>
        jobShipmentData.shipment_mode.includes(e.value)
      );
      if (serviceTypeValue === "" || shipmentValue === "") {
        this.setState({ serviceTypeValue: sData, shipmentValue: shipData });
      }
    }
  }

  handleSelectChange = (e, key) => {
    const { onChangeValue, paymentInformation } = this.props;
    const token = this.state.retailers
      .filter((item) => item.value === e.target.value)
      .map((item) => item.referral_token);
    const salesPerson = this.state.retailers.find(
      (item) => item.value === e.target.value
    )?.sales_person;
    const retailername = this.state.retailers.find(
      (item) => item.value === e.target.value
    )?.label;

    // get customer discount and calculate
    this.getRetailerDetailById(e.target.value).then((data) => {
      if (paymentInformation.actual_amount) {
        let discount = (paymentInformation.actual_amount * data) / 100;
        let bookingAmt =
          Number(paymentInformation.actual_amount) - Number(discount);
        let breakdown = paymentInformation.breakdown;
        breakdown.discount_amount = discount;
        onChangeValue({ value: breakdown }, "payment_information", "breakdown");
        onChangeValue(
          { value: bookingAmt },
          "payment_information",
          "booking_amount"
        );
      }
    });
    let data = {
      ...this.props.generalDetails,
      [e.target.name]: e.target.value,
      ["retailer_name"]: retailername,
      ["referral_code"]: token[0],
      ["sales_person"]: salesPerson,
    };
    onChangeValue({ value: data }, "general_details", "general_details");
    // onChangeValue(e, 'general_details')
    // onChangeValue({ value: token[0] }, 'general_details', 'referral_code')
  };

  handleJobStatus = (e) => {
    if (!e.target.value) return false;
    this.setState({
      optionalJobStatus: e.target.value,
      showJobStatusModal: true,
    });
  };

  handleSubmitJobStatus = () => {
    const { onChangeValue } = this.props;
    let payload = {
      job_token: this.props.jobToken,
      status: this.state.optionalJobStatus.toUpperCase(),
    };
    JobService.setJobOpenStatus(payload).then((result) => {
      if (result.status) {
        this.setState({
          jobStatus: this.state.optionalJobStatus,
          showJobStatusModal: false,
        });
        this.setData();
        onChangeValue(
          { value: this.state.optionalJobStatus.toLowerCase() },
          "is_job_open",
          "is_job_open"
        );
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    });
  };

  getSalesPerson = (generalDetails, jobCustData) => {
    if (generalDetails?.sales_person?.contact_name) {
      return generalDetails?.sales_person?.contact_name;
    } else if (generalDetails.sales_person) {
      return generalDetails.sales_person;
    } else if (jobCustData?.sales_person) {
      return jobCustData.sales_person;
    }
  };

  getInvoices = () => {
    let jId = this.props.jobId;
    jId &&
      revenuecostService.getInvoice({ jId }).then((result) => {
        if (result.status === true) {
          let apiData = result.data;
          let totalAgreedAmount = apiData.reduce(
            (total, item) => total + item.gross_amount,
            0
          );
          let invoicepdfstate = result.data.map((acc, cur) => {
            acc[cur._id] = false;
            return acc;
          }, {});


          let CheckDraft = result.data.find((e) => {
            return e.draft === true;
          });

          this.setState(
            {
              invoices: result.data,
              invoicePdfState: invoicepdfstate,
              agreedAmt: totalAgreedAmount,
              isDraft : CheckDraft ? true : false
            },
            () => {
              this.props.onChangeValue(
                { value: totalAgreedAmount },
                "payment_information",
                "agreed_amount"
              );
            }
          );

        }
      });
  };


  getCosts = () => {
    let jId = this.props.jobId;
    jId &&
      revenuecostService.getCost({ jId }).then((result) => {
        if(result.status === true){
          this.setState({
            costs : result.data
          })
        }
        // if (result.status === true) {
        //   let data = result.data;
        //   let findCost= result?.data.find(
        //     (item) => item.draft === true
        //   )
        // this.props.checkCost(findCost?.draft)
        //   for (let i = 0; i < data.length; i++) {
        //     data[i].qbook_vendor =
        //       data[i].qbook_vendor + "_" + data[i].qbook_vendor_name;
        //     data[i].glc_amount = data[i].gross_amount;
        //   }
        //   this.setState({ cost: data });
        // }
      });
  };

  checkJobStatus = () => {};

  render() {
    const {
      serviceTypeValue,
      shipmentValue,
      retailers,
      jobStatus,
      customers,
      myData,
      emp_name

    } = this.state;
    const {
      jobCustData,
      jobShipmentData,
      jobToken,
      generalDetails,
      paymentInformation,
      isJobOpen,
      onChangeValue,
      jobId,
      formValidator,
      jobData,
      stateData,
      isview
    } = this.props;
    // console.log(generalDetails,'generalDetails')
    const {jobFinancialStatus , isDraftedInvoice , isDraftedCost} = stateData
    if (!jobCustData || Object.keys(jobCustData).length === 0) return false;
    if (!jobShipmentData || Object.keys(jobShipmentData).length === 0)
      return false;
    if (!generalDetails || Object.keys(generalDetails).length === 0)
      return false;
    this.setData();

    const retailerId = generalDetails.retailer_id
      ? generalDetails.retailer_id
      : generalDetails.sales_person?._id;


      // console.log(this.getSalesPerson(generalDetails, jobCustData), "this.getSalesPerson(generalDetails, jobCustData)")





    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="card ">
              <div className="card-body">
                <h5>Job Details</h5>
                <div className="mb-2">
                  <label className="form-label">Job/Booking No.</label>
                  <input
                    className="form-control form-control-sm"
                    value={jobToken}
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Date</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      jobData?.updated_at
                        ? moment(jobData.updated_at).format("DD-MM-YYYY")
                        : jobData?.created_at
                        ? moment(jobData.created_at).format("DD-MM-YYYY")
                        : null
                    }
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="card ">
              <div className="card-body">
                <h5>Customer Details</h5>

                <div className="mb-2">
                  <label className="form-label">Name</label>
                  <input
                    className="form-control form-control-sm"
                    value={jobCustData.name}
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Email</label>
                  <input
                    className="form-control form-control-sm"
                    value={jobCustData.email}
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Mobile No</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      (jobCustData?.mobile_number &&
                        ((jobCustData?.mobile_number.includes("undefined") &&
                          "+" +
                            jobCustData?.mobile_number.split("undefined")[1]) ||
                          jobCustData?.mobile_number)) ||
                      (this.props?.userDetails &&
                        this.props.userDetails.length > 0 &&
                        this.props.userDetails[0].user_phone_number) ||
                      // && this.props.userDetails[0].user_phone_number.includes('undefined') && '+'+this.props.userDetails[0].user_phone_number.split('undefined')[1]
                      ""
                    }
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Customer Type : </label>
                  <b> {jobCustData.user_type} </b>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card">
              <div className="card-body">
                <h5>Shipment Details</h5>

                <div className="mb-2">
                  <label className="form-label">Origin</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      jobShipmentData.origin +
                      ((jobShipmentData?.origin_country &&
                        ", " + jobShipmentData.origin_country) ||
                        "")
                    }
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Destination</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      jobShipmentData.destination +
                      ((jobShipmentData?.destination_country &&
                        ", " + jobShipmentData.destination_country) ||
                        "")
                    }
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Value of Goods</label>
                  <input
                    className="form-control form-control-sm"
                    value={jobShipmentData.value_of_goods}
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Shipment Type : </label>
                  <b> {jobShipmentData.shipment_type}</b>
                </div>

                <div className="mb-2">
                  <label className="form-label">Shipment Mode : </label>
                  <b>
                    {shipmentValue !== "" &&
                      shipmentValue.length > 0 &&
                      shipmentValue[0].label}
                  </b>
                </div>

                <div className="mb-2">
                  <label className="form-label">Service Type : </label>
                  <b>
                    {serviceTypeValue !== "" &&
                      serviceTypeValue.length > 0 &&
                      serviceTypeValue[0].label}
                  </b>
                </div>

                <div className="mb-2">
                  <label className="form-label">
                    Job Status {isJobOpen.toLowerCase()}{" "}
                  </label>

                  <Form.Select
                    disabled={(isview || jobFinancialStatus || isDraftedInvoice || isDraftedCost) ? true : false}
                    name="is_job_open"
                    value={jobStatus}
                    onChange={(e) => this.handleJobStatus(e)}
                  >
                    <option value="">Select</option>
                    <option value="OPEN">Open</option>
                    <option value="CLOSE">Close</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card">
              <div className="card-body">
                <h5>Payment Information</h5>

                <div className="mb-2">
                  <label className="form-label">Booking Amount</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      paymentInformation && paymentInformation.booking_amount
                    }
                    disabled
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Actual Amount</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      paymentInformation && paymentInformation.actual_amount
                    }
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Agreed Amount</label>
                  <input
                    className="form-control form-control-sm"
                    value={
                      paymentInformation &&
                      helperFunction.handleDecimalPoints(
                        paymentInformation.agreed_amount,
                        3
                      )
                    }
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Advance Amount</label>
                  <input
                    className="form-control form-control-sm"
                    readOnly
                    value={
                      paymentInformation &&
                      paymentInformation.job_advance_payment
                    }
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label">Status</label>
                  <input
                    className="form-control form-control-sm"
                    readOnly
                    value={
                      paymentInformation && paymentInformation.payment_status
                    }
                  />
                  {/* <Select
                                        options={JobOptions.paymentOption()}
                                        name="shipment_type"
                                        value={JobOptions.paymentOption().filter(obj => obj.value === paymentInformation.payment_status)}
                                        // value={paymentInformation && paymentInformation.payment_status}
                                        onChange={e => onChangeValue(e, 'payment_information', 'payment_status')}
                                    /> */}
                </div>
                <div className="mb-2">
                  <label className="form-label">Freight : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.freight}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Packing Charge : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.packing_charge}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Insurance : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.insurance}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Storage : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.storage}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Booking Amount : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.bookingAmount}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Discount Amount : </label>
                  <b>
                    {" "}
                    {paymentInformation &&
                      paymentInformation.breakdown &&
                      paymentInformation.breakdown.discount_amount}{" "}
                  </b>
                </div>
                <div className="mb-2">
                  <label className="form-label">Credit Note Amount : </label>
                  <b>
                    {" "}
                    {paymentInformation && paymentInformation.credit_note_amount
                      ? paymentInformation.credit_note_amount
                      : 0}{" "}
                  </b>
                </div>
              </div>
            </div>
          </div>

          <Col>
            <div className="card">
              <div className="card-body">
                <h5>General Details</h5>

                <Form.Group className="mb-2">
                  <Form.Label>W2D Sales Person</Form.Label>
                  <Form.Control
                    size="sm"
                    value={this.getSalesPerson(generalDetails, jobCustData)}
                    readOnly
                  />
                </Form.Group>


                      {/* { */}
                        {/* myData === "customer_service" &&
                        <Form.Group className="mb-2">
                  <Form.Label>Customer Service</Form.Label>
                  <Form.Control
                    size="sm"
                    value={emp_name}
                    readOnly
                  />
                </Form.Group> || */}
                <Form.Group className="mb-2">
                  <Form.Label>Customer Service</Form.Label>
                  <Select
                    isDisabled={emp_name ? true : false}
                    options={customers}
                    onChange={(e) =>
                      onChangeValue(e, "general_details", "customer_service")
                    }
                    // to get value on referral change
                    // value={customers.find((item) => {
                    //   if (
                    //     item?.employee_name === generalDetails?.customer_service
                    //   ) {
                    //     return item;
                    //   }
                    // })}
                    value={customers.find((itm)=> itm.value===generalDetails.customer_service)}
                  />
                  {/* <Form.Control size="sm"
                                        name="customer_service"
                                        value={generalDetails.customer_service}
                                        onChange={(e) => onChangeValue(e, 'general_details')}
                                    /> */}
                  {formValidator.message(
                    "Customer Service",
                    generalDetails.customer_service,
                    "required",
                    { className: "text-danger" }
                  )}
                </Form.Group>
                      {/* } */}

                {/* <div className="mb-2">
                  <label className="form-label">Name</label>
                  <input
                    className="form-control form-control-sm"
                    value={jobCustData.name}
                    disabled
                  />
                </div> */}

              

                {/* <Form.Group className="mb-2" >
                                    <Form.Label>Person Code</Form.Label>
                                    <Form.Control size="sm" />
                                </Form.Group> */}

                <Form.Group className="mb-2">
                  <Form.Label>Retailer</Form.Label>
                  <Form.Select
                    name="retailer_id"
                    value={retailerId}
                    onChange={(e) =>
                      this.handleSelectChange(e, "general_details")
                    }
                  >
                    <option>Select</option>
                    {retailers.map((item) => {
                      if (
                        this.props.generalDetails?.retailer_name === item?.label
                      ) {
                        return (
                          <option selected value={item.value}>
                            {item.label}
                          </option>
                        );
                      } else {
                        return <option value={item.value}>{item.label}</option>;
                      }
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Referral Code</Form.Label>
                  <Form.Control
                    size="sm"
                    // value={generalDetails.sales_person?generalDetails.sales_person.referral_token:''}

                    value={
                      generalDetails.sales_person
                        ? generalDetails.sales_person.referral_token
                          ? generalDetails.sales_person.referral_token
                          : generalDetails.referral_code
                        : generalDetails.referral_code
                    }
                    readOnly
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Overseas Agent</Form.Label>
                  <Form.Control
                    size="sm"
                    name="overseas_agent"
                    value={generalDetails.overseas_agent}
                    onChange={(e) => onChangeValue(e, "general_details")}
                  />
                </Form.Group>

                {/*  <Form.Group className="mb-2" >
                                    <Form.Label>Customer Type</Form.Label>
                                    <Form.Control size="sm" value={generalDetails.customer_type} />
                                </Form.Group> */}

                {/* <Form.Group className="mb-2" >
                                    <Form.Label>End Customer Type</Form.Label>
                                    <Form.Control size="sm"
                                        name="end_customer_type"
                                        value={generalDetails.end_customer_type}
                                        onChange={(e) => onChangeValue(e, 'general_details')}
                                    />
                                </Form.Group> */}

                <div className="mb-2">
                  <label className="form-label">End Customer Type</label>

                  <Form.Select
                    name="end_customer_type"
                    value={generalDetails.end_customer_type}
                    onChange={(e) => onChangeValue(e, "general_details")}
                  >
                    <option>Select</option>
                    {JobOptions.endCustomerType().map((item,i) => {
                      return <option key={i} value={item.value}>{item.label}</option>;
                    })}
                  </Form.Select>
                </div>

                <div className="mb-2">
                  <label className="form-label">Shipment Category</label>

                  <Form.Select
                    name="shipment_category"
                    value={generalDetails.shipment_category}
                    onChange={(e) => onChangeValue(e, "general_details")}
                  >
                    <option>Select</option>
                    {JobOptions.shipmentCategory().map((item,i) => {
                      return <option key={i} value={item.value}>{item.label}</option>;
                    })}
                  </Form.Select>
                </div>
              </div>
            </div>
          </Col>
          <Modal
            size="sx"
            show={this.state.showJobStatusModal}
            onHide={() => this.setState({ showJobStatusModal: false })}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                Change Job Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are You Sure Want to Change Job Status to{" "}
              {this.state.optionalJobStatus}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.setState({ showJobStatusModal: false })}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={this.handleSubmitJobStatus}>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default QuickInfo;
